<template>
  <div>
    <bw-table
        aria-label="data-table"
        :display-filters="displayFilters"
        :headers="headers"
        :items="localPasses"
        hide-row-select
        :showSearch="true"
    >
  
      <template v-slot:item.name="{ item: pass }">
        <div
            class="text-subtitle-2"
            style="flex-wrap: nowrap !important;"
        >
          {{ pass.name }} {{pass.deleted ? '(Archived)' : ''}}
        </div>
      </template>
      <template v-slot:item.template_name="{ item: pass }">
        <div
            class="text-subtitle-2"
            style="flex-wrap: nowrap !important;"
        >
          {{ pass.template?.name }}
        </div>
      </template>
      <template v-slot:item.created_at="{ item: pass }">
        {{ moment(pass.created_at).format('L') }}
      </template>
      <template v-slot:item.actions="{ item: pass }">
        <div class="d-flex justify-end">
          <v-btn
              class="me-2 me-md-4 ml-auto"
              color="secondary"
              depressed
              fab
              :href="editPass(pass)"
              outlined
              small
          >
            <v-icon>
              mdi-pencil-outline
            </v-icon>
          </v-btn>
          <v-btn
              v-if="!pass.deleted"
              color="error"
              depressed
              fab
              @click="showConfirmRemoveDialog(pass)"
              outlined
              small
          >
            <v-icon>
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
          <v-btn
              v-else
              color="secondary"
              depressed
              fab
              @click="showConfirmRecoverItem(pass)"
              outlined
              small
          >
            <v-icon>
              mdi-undo-variant
            </v-icon>
          </v-btn>
        </div>
      </template>
    </bw-table>
    <confirm-dialog
        :description="(itemToUpdate && itemToUpdate.deleted == 1) ? 'Please click \'Confirm\' to archive this item. You will be able to recover this item by filtering by \'Archived\' in the future.' : 'Are your sure?'"
        :open="!!itemToUpdate"
        :title="confirmDialogTitle"
        @cancel="() => itemToUpdate = null"
        @confirm="() => itemToUpdate.deleted == 1 ? doRemove() : doRecover()"
    ></confirm-dialog>
  </div>
</template>

<script>
 

import ConfirmDialog from "../../../../Shared/UI/ConfirmDialog.vue";

export default {
	name: 'ListPasses',
  components: {
    ConfirmDialog,
  },
	props: {
		extraData: {
			type: Object,
			default: () => ({})
		},
		passes: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
            confirmDialogTitle: '',
			displayFilters: {
				templates: {
					name: 'Pass Type',
					type: 'select',
					data: this.extraData.usedTemplates,
					position: 'main',
					clearable: true,
					filterOn: 'template_id',
					filterEmpty: this.passes?.filter(item => !item.template_id)?.length > 0
							? '-- Blank --'
							: null,
				},
				archived: {
					name: 'Archived',
					type: 'checkbox',
					default: false,
					position: 'main',
					filterOnFalse: 'deleted',
				},
			},
			headers: [
				{
					align: 'end',
					mandatory: true,
					text: 'ID',
					value: 'id',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					text: 'Pass',
					value: 'name'
				},

				{
					align: 'start',
					mandatory: true,
					text: 'Type',
					value: 'template_name',
					width: '15%'
				},
        {
          align: 'start',
          mandatory: true,
          text: 'Created Date',
          value: 'created_at',
          width: '1%'
        },
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
      itemToUpdate: null,
      localPasses: [],
		};
	},
  mounted() {
    this.localPasses = this.passes;
  },
	computed: {
		avatarSize() {
			if(this.$vuetify.breakpoint.xsOnly) return 36;
			if(this.$vuetify.breakpoint.smOnly) return 40;
			if(this.$vuetify.breakpoint.mdOnly) return 44;
			return 48;
		},
	},
	created() {
	},
	methods: {
		editPass(pass) {
			return `/partner-portal/${this.partner.id}/passes/${pass.id}/name`;
		},
    doRemove() {
      this.saveChanges('Pass removed.'); 
    },
    doRecover() {
      this.saveChanges('Pass recovered.');
    },
    async refreshPasses() {
      try {
        const { data } = await axios.get(`/partner-portal/${this.partner.id}/passes/list`);
        this.localPasses = data.allPasses;
      }
      catch (error) {
        window.EventBus.$emit('system-messages', [
          { message: error.message, messageType: 'error' }
        ]);
      }
    },
    showConfirmRemoveDialog(item) {
        this.confirmDialogTitle = 'Remove Pass';
        this.itemToUpdate = {id: item.id, type: item.type, deleted: 1};
    },
    showConfirmRecoverItem(item) {
        this.confirmDialogTitle = 'Recover Pass';
        this.itemToUpdate = {id: item.id, type: item.type, deleted: 0};
    },
    async saveChanges(actionMessage) {
      const pass = this.itemToUpdate;
      this.isSaving = true;
      const url = `/partner-portal/${this.partner.id}/passes/save-pass/${pass.id}`;

      try {
        const { data } = await axios.put(url,pass);
        this.itemToUpdate = null;
        const message = `${actionMessage} Retrieving passes list...`;
        window.EventBus.$emit('system-messages', [
          {
            message,
            messageType: 'success',
            showOverlay: true
          }
        ]);
        await this.refreshPasses();
      }
      catch (error) {
        this.isSaving = false;
        window.EventBus.$emit('system-messages', [
          { message: error.message, messageType: 'error' }
        ]);
      }
    },
	}
};
</script>

<style lang="scss" scoped></style>
